import Class from './budget';
import './budget@';

export default Class;